import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { BulkActionJobSummaryDto } from './bulkActions.types';

const ENDPOINT = `${APIConfiguration.search}bulkActions/${COMMON_QUERY_PARAMS.ID}`;

export interface GetBulkActionJobQueryArgs {
  id: string;
}

async function getBulkActionJobQuery({
  id,
}: GetBulkActionJobQueryArgs): Promise<
  BackResponse<BulkActionJobSummaryDto> | BackResponseFailure
> {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.ID, id);

    return await apiCall<BackResponse<BulkActionJobSummaryDto>>(url, {
      method: SUPPORTED_METHODS.GET,
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getBulkActionJobQuery;
